import { Style, Avatar } from '@dicebear/core';
import definition from '@dicebear/styles/lorelei.json' with { type: 'json' };

const style = new Style(definition);

export const getAvatarUrl = (seedOrUrl: string): string => {
  if (!seedOrUrl) return '';
  
  // If it's an existing dicebear URL, extract the seed to generate locally
  const match = seedOrUrl.match(/seed=([^&]+)/);
  let seed = seedOrUrl;
  
  if (match) {
    seed = match[1];
  } else if (seedOrUrl.startsWith('http') || seedOrUrl.startsWith('data:')) {
    // If it's a non-dicebear URL (like Google profile photo), return it as is
    return seedOrUrl;
  }
  
  const avatar = new Avatar(style, {
    seed: seed || 'Felix'
  });
  
  return avatar.toDataUri();
};

// Use this when saving to Firebase to avoid "Photo URL too long" errors
export const getStorageAvatarUrl = (seed: string): string => {
  return `https://api.dicebear.com/9.x/lorelei/svg?seed=${seed}`;
};
